import React from 'react';
import {getMediaURL, truncate} from "../../../../../config/values";
import {Link} from "react-router-dom";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../../config/design/styles";
import {Typography} from "@mui/material";

function CategorySliderItem({category,classes,industry}) {
    return (
        <Link to={`/${industry}/discover?categories=${category.id}`} className={classes.categorySliderItem}>
            <img src={getMediaURL(category.file,'small')} alt={category.name}/>
            <Typography align="center" className='font-12'>{truncate(category.name ,13)}</Typography>
        </Link>
    );
}

export default withStyles(Styles)(CategorySliderItem);
